import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { setError } from "../../../../../Redux/ErrorRedux";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Container from "../../../../../modules/commons/Container";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { mapToObjectDDL } from "../../../../common/mapper";
import { monthOptions, yearOptions } from "../../config";
import ReportAsalProspek from "./components/reportAsalProspek";
import ReportReasonDrop from "./components/reportReasonDrop";

class DashboardMonitoringTambahanKabengKacab extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));

    this.state = {
      isAllSelected: true,
      isSpecificSelected: false,
      cabangOptions: [],
      kodeCabang: null,
      search: {},
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      loading: false,
      doSearch: false,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "Dashboard CRM Kabeng Kacab - Prospek Monitoring",
    });
    this.handleTriggerLoading();
    if (res.ok) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang),
      );

      if (filteredData.length !== 0) {
        this.setState(
          (prev) => ({
            ...prev,
            cabangOptions: filteredData.map((item) =>
              mapToObjectDDL(item.namaDealer, item.kodeCabang),
            ),
            search: {
              ...prev.search,
              month: prev.month,
              year: prev.year,
            },
          }),
          () => this.handleSearch(),
        );
      }
    }
  };

  handleSelectCabang = (e, type) => {
    const isChecked = e.target.checked;

    if (type === "ALL") {
      this.setState((prevValue) => ({
        ...prevValue,
        isAllSelected: isChecked,
        isSpecificSelected: false,
        kodeCabang: [],
      }));
    }

    if (type === "SPECIFIC") {
      this.setState((prevValue) => ({
        ...prevValue,
        isSpecificSelected: isChecked,
        isAllSelected: false,
        kodeCabang: [],
      }));
    }
  };

  handleChangeValue = (name, value) => {
    this.setState((prevValue) => ({ ...prevValue, [name]: value }));
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  handleSuccessSearch = () => {
    this.setState({ doSearch: false });
  };

  handleSearch = () => {
    this.setState({ doSearch: true });
  };

  render() {
    const {
      isAllSelected,
      isSpecificSelected,
      cabangOptions,
      kodeCabang,
      month,
      year,
      loading,
      doSearch,
    } = this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView
            style={{ gap: "20px", alignItems: "center" }}
            className="margin-top-15px"
          >
            <SimpleCheckBox
              id="reportAllCabang"
              key="reportAllCabang"
              name="reportAllCabang"
              label="ALL CABANG"
              checked={isAllSelected}
              onChange={(e) => this.handleSelectCabang(e, "ALL")}
            />
            <SimpleCheckBox
              id="reportSpecificCabang"
              key="reportSpecificCabang"
              name="reportSpecificCabang"
              label="SPESIFIK CABANG"
              checked={isSpecificSelected}
              onChange={(e) => this.handleSelectCabang(e, "SPECIFIC")}
            />
            <SimpleDDL
              id="select_options_kode_cabang"
              box="multiselect"
              name="kodeCabang"
              containerclassname="width width-500px"
              placeholder="Nama Cabang"
              readOnly={!isSpecificSelected}
              options={cabangOptions}
              value={kodeCabang}
              onChange={(value, { name }) =>
                this.handleChangeValue(name, value)
              }
            />
          </FlexView>
          <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
            <SimpleDDL
              id="select_options_bulan"
              box="search"
              name="month"
              containerclassname="width width-150px"
              placeholder="Bulan"
              options={monthOptions}
              value={month}
              onChange={(value, { name }) =>
                this.handleChangeValue(name, value)
              }
            />
            <SimpleDDL
              id="select_options_tahun"
              box="search"
              name="year"
              containerclassname="width width-150px"
              placeholder="Tahun"
              options={yearOptions}
              value={year}
              onChange={(value, { name }) =>
                this.handleChangeValue(name, value)
              }
            />
            <SimpleButton
              id="btn_search"
              text="Cari"
              className="margin margin-top-5px"
              onClick={() => this.handleSearch()}
            />
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Statistik Asal Prospek</Tab>
              <Tab>Laporan Statistik DROP</Tab>
            </TabList>
            <TabPanel key="asal_prospek">
              <ReportAsalProspek
                {...this.props}
                isAllSelected={isAllSelected}
                kodeCabang={kodeCabang}
                cabangOptions={cabangOptions}
                month={month}
                year={year}
                doSearch={doSearch}
                onSuccessSearch={this.handleSuccessSearch}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel key="prospek_drop">
              <ReportReasonDrop
                {...this.props}
                isAllSelected={isAllSelected}
                kodeCabang={kodeCabang}
                cabangOptions={cabangOptions}
                month={month}
                year={year}
                doSearch={doSearch}
                onSuccessSearch={this.handleSuccessSearch}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
          </Tabs>
        </Container>
        {loading && <SimpleLoadingOverlay active={loading} />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setError: (payload) => dispatch(setError(payload)),
});

const mapStateToProps = (state) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardMonitoringTambahanKabengKacab);
